<form ui-form [formGroup]="validateForm" (ngSubmit)="submitForm()">
  <ui-form-item>
    <ui-form-label [uiSm]="6" [uiXs]="24" uiRequired uiFor="email">E-mail</ui-form-label>
    <ui-form-control [uiSm]="14" [uiXs]="24" uiErrorTip="The input is not valid E-mail!">
      <input ui-input formControlName="email" id="email" />
    </ui-form-control>
  </ui-form-item>
  <ui-form-item>
    <ui-form-label [uiSm]="6" [uiXs]="24" uiFor="password" uiRequired>Password</ui-form-label>
    <ui-form-control [uiSm]="14" [uiXs]="24" uiErrorTip="Please input your password!">
      <input ui-input type="password" id="password" formControlName="password" (ngModelChange)="updateConfirmValidator()" />
    </ui-form-control>
  </ui-form-item>
  <ui-form-item>
    <ui-form-label [uiSm]="6" [uiXs]="24" uiFor="checkPassword" uiRequired>Confirm Password</ui-form-label>
    <ui-form-control [uiSm]="14" [uiXs]="24" [uiErrorTip]="errorTpl">
      <input ui-input type="password" formControlName="checkPassword" id="checkPassword" />
      <ng-template #errorTpl let-control>
        <ng-container *ngIf="control.hasError('required')">Please confirm your password!</ng-container>
        <ng-container *ngIf="control.hasError('confirm')"> Two passwords that you enter is inconsistent! </ng-container>
      </ng-template>
    </ui-form-control>
  </ui-form-item>
  <ui-form-item>
    <ui-form-label [uiSm]="6" [uiXs]="24" labelFor="nickname" labelRequired ui-tooltip uiTooltipTitle="What do you want other to call you">
      <span>Nickname</span>
    </ui-form-label>
    <ui-form-control [uiSm]="14" [uiXs]="24" uiErrorTip="Please input your nickname!">
      <input ui-input id="nickname" formControlName="nickname" />
    </ui-form-control>
  </ui-form-item>
  <ui-form-item>
    <ui-form-label [uiSm]="6" [uiXs]="24" uiFor="phoneNumber" uiRequired>Phone Number</ui-form-label>
    <ui-form-control [uiSm]="14" [uiXs]="24" [nzValidateStatus]="validateForm.controls['phoneNumber']" uiErrorTip="Please input your phone number!">
      <ui-input-group [uiAddOnBefore]="addOnBeforeTemplate">
        <ng-template #addOnBeforeTemplate>
          <ui-select formControlName="phoneNumberPrefix" class="phone-select">
            <ui-option nzLabel="+86" nzValue="+86"></ui-option>
            <ui-option nzLabel="+87" nzValue="+87"></ui-option>
          </ui-select>
        </ng-template>
        <input formControlName="phoneNumber" id="'phoneNumber'" ui-input />
      </ui-input-group>
    </ui-form-control>
  </ui-form-item>
  <ui-form-item>
    <ui-form-label [uiSm]="6" [uiXs]="24" uiFor="website" uiRequired>Website</ui-form-label>
    <ui-form-control [uiSm]="14" [uiXs]="24" uiErrorTip="Please input website!">
      <input ui-input id="website" formControlName="website" placeholder="website" />
    </ui-form-control>
  </ui-form-item>
  <ui-form-item>
    <ui-form-label [uiSm]="6" [uiXs]="24" labelFor="captcha" labelRequired ui-tooltip uiTooltipTitle="Please click 'Get captcha'"> Captcha </ui-form-label>
    <ui-form-control [uiSm]="14" [uiXs]="24" formControlErrorTip="Please input the captcha you got!" nzExtra="We must make sure that your are a human.">
      <div ui-row [uiGutter]="8">
        <div ui-col [uiSpan]="12">
          <input ui-input formControlName="captcha" id="captcha" />
        </div>
        <div ui-col [uiSpan]="12">
          <button ui-button (click)="getCaptcha($event)">Get captcha</button>
        </div>
      </div>
    </ui-form-control>
  </ui-form-item>
  <ui-form-item ui-row class="register-area">
    <ui-form-control [uiSpan]="14" [uiOffset]="6">
      <label ui-checkbox formControlName="agree">
        <span>
          I have read the
          <a>agreement</a>
        </span>
      </label>
    </ui-form-control>
  </ui-form-item>
  <ui-form-item ui-row class="register-area">
    <ui-form-control [uiSpan]="14" [uiOffset]="6">
      <button ui-button nzType="primary">Register</button>
    </ui-form-control>
  </ui-form-item>
</form>
